export const queryKeys = {
  teamRosterPlayers: {
    all: ['teamRosterPlayers'],
    byTeam: (teamId) => [...queryKeys.teamRosterPlayers.all, teamId],
    byRoster: (teamId, rosterId) => [
      ...queryKeys.teamRosterPlayers.byTeam(teamId),
      rosterId,
    ],
  },
  game: {
    all: ['game'],
    byId: (gameId, isPublic) => [...queryKeys.game.all, gameId, !!isPublic],
  },
  gameRosters: {
    all: ['gameRosters'],
    byGame: (gameId) => [...queryKeys.gameRosters.all, gameId],
  },
  gameRosterPlayers: {
    all: ['gameRosterPlayers'],
    byRoster: (gameId, gameRosterId) => [
      ...queryKeys.gameRosterPlayers.all,
      gameId,
      gameRosterId,
    ],
  },
  gameRosterUsers: {
    all: ['gameRosterUsers'],
    byRoster: (gameId, gameRosterId) => [
      ...queryKeys.gameRosterUsers.all,
      gameId,
      gameRosterId,
    ],
  },
  playerHighlights: {
    all: ['playerHighlights'],
    byPlayer: (playerId) => [...queryKeys.playerHighlights.all, playerId],
    byProfilePlayers: (playerIds) => [
      ...queryKeys.playerHighlights.all,
      'profile',
      playerIds,
    ],
  },
  userPlayers: {
    all: ['userPlayers'],
    me: () => [...queryKeys.userPlayers.all, 'me'],
  },
  highlight: {
    all: ['highlight'],
    byId: (highlightId) => [...queryKeys.highlight.all, highlightId],
  },
  myRegistrations: {
    all: ['myRegistrations'],
  },
  pendingInstallments: {
    all: ['pendingInstallments'],
  },
  pendingDeposits: {
    all: ['pendingDeposits'],
  },
  userBilling: {
    all: ['userBilling'],
    byId: (billingId) => [...queryKeys.userBilling.all, billingId],
  },
  gameTimeline: {
    all: ['gameTimeline'],
    byGame: (gameId) => [...queryKeys.gameTimeline.all, gameId],
  },
  gameEvents: {
    all: ['gameEvents'],
    byGame: (gameId) => [...queryKeys.gameEvents.all, gameId],
  },
  gameScoreboard: {
    all: ['gameScoreboard'],
    byGame: (gameId) => [...queryKeys.gameScoreboard.all, gameId],
  },
  gameSettings: {
    all: ['gameSettings'],
    byGame: (gameId) => [...queryKeys.gameSettings.all, gameId],
  },
  orgCompetitions: {
    all: ['orgCompetitions'],
    byOrg: (orgId) => [...queryKeys.orgCompetitions.all, orgId],
    bySearch: (orgId, search, filters) => [
      ...queryKeys.orgCompetitions.byOrg(orgId),
      search,
      // filters object is stable-stringified by react-query's key hashing,
      // so different sport filter combos get distinct cache entries.
      filters ?? null,
    ],
  },
  teamSearch: {
    all: ['teamSearch'],
    notRegistered: (scheduleId, query, isGlobal) => [
      ...queryKeys.teamSearch.all,
      'notRegistered',
      scheduleId,
      query,
      isGlobal,
    ],
  },
  // Scoring-context settings: same endpoint as gameSettings, but stored
  // verbatim from req() (no unwrapping) to match what ScoringContext's
  // setSettings(data) has stored historically. Keep this separate from
  // gameSettings so we don't fight over the cache shape with the existing
  // common/features/game/hooks/useGameSettings hook (which unwraps).
  scoringContextSettings: {
    all: ['scoringContextSettings'],
    byGame: (gameId) => [...queryKeys.scoringContextSettings.all, gameId],
  },
  gameHighlights: {
    all: ['gameHighlights'],
    byGame: (gameId) => [...queryKeys.gameHighlights.all, gameId],
  },
  gameShootout: {
    all: ['gameShootout'],
    byGame: (gameId) => [...queryKeys.gameShootout.all, gameId],
  },
}
